import React, { Fragment } from "react";

export const Address = () => (
  <Fragment>
    Learnpulse SAS
    <br />
    15 rue Théodore de Banville
    <br />
    31200 TOULOUSE
    <br />
    FRANCE
  </Fragment>
);